import React from 'react';
import Chip from '@material-ui/core/Chip';
import ThemeProvider, { providers } from 'common/material-ui-theme';
import { LBButton, LBXIcon } from '@linearb/buzz';

const SIZES = {
  mini: {
    maxWidth: '7rem',
    minWidth: '3rem',
    maxHeight: '2rem',
    minHeight: '2rem',
    padding: 'inherit',
    fontSize: '1rem'
  },
  flex: {
    padding: '1.6rem 0 1.5rem 0',
    fontSize: '1.2rem',
    maxHeight: '2rem',
    minHeight: '2rem'
  },
  medium: {
    padding: '1.6rem 0 1.5rem 0',
    fontSize: '1.2rem'
  },
  small: {
    maxWidth: '7rem',
    minWidth: '7rem',
    maxHeight: '2rem',
    minHeight: '2rem',
    padding: 'inherit',
    fontSize: '1rem'
  },
  auto: {
    maxHeight: '2rem',
    minHeight: '2rem',
    padding: 'inherit',
    fontSize: '1rem'
  }
};

/*
 * Note: If you would like to add a new color or view the existing colors, go to material-ui-theme.js and add your color to the MuiChip object
 */
const CustomizedChip = ({
  size,
  textColor,
  label,
  isDashed,
  isFitContent,
  dataCy,
  color = 'primary',
  bold = false,
  ...rest
}) => {
  const styles = {
    ...SIZES[size],
    ...(textColor ? { color: textColor } : {}),
    ...(bold ? { fontWeight: 500 } : {}),
    ...(isDashed ? { borderStyle: 'dashed' } : {}),
    ...(isFitContent ? { maxWidth: 'fit-content' } : {})
  };

  const Theme = Object.keys(providers).includes(color)
    ? providers[color]
    : ThemeProvider;
  return (
    <Theme>
      <Chip
        label={label}
        style={styles}
        color='primary'
        data-cy={dataCy}
        deleteIcon={
          <span>
            {/* can't use ghost button here as it overlaps with the chip border */}
            <LBButton size='icon' variant='link' id='Close'>
              <LBXIcon />
            </LBButton>
          </span>
        }
        {...rest}
      />
    </Theme>
  );
};

export default CustomizedChip;
